module.exports = __webpack_public_path__ + "static/img/ls7.8d91345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/ls7.png
// module id = zjoj
// module chunks = 12